// frontend-react/src/hooks/useProjectionEngine.js
// Chunk 30 Model Switcher — reads/writes the user's projection-engine preference
// (consensus | pattern_spotter | cautious_forecaster). Default consensus (spec).
import { useState, useEffect, useCallback } from 'react';
import api from '../services/apiService';

const DEFAULT_ENGINE = 'consensus';

export const useProjectionEngine = () => {
  const [engine, setEngine] = useState(DEFAULT_ENGINE);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get('/api/account/projection-engine')
      .then((res) => { if (alive) setEngine(res.data?.projectionEngine || DEFAULT_ENGINE); })
      .catch(() => { if (alive) setEngine(DEFAULT_ENGINE); })
      .finally(() => { if (alive) setLoaded(true); });
    return () => { alive = false; };
  }, []);

  // Optimistic update + persist; revert engine on failure.
  const selectEngine = useCallback((next) => {
    setEngine((prev) => {
      api.put('/api/account/projection-engine', { projectionEngine: next })
        .catch(() => setEngine(prev));
      return next;
    });
  }, []);

  return { engine, selectEngine, loaded };
};

export default useProjectionEngine;
